<template>
    <v-dialog
        v-model="dialogOpen"
        max-width="500"
        persistent
    >
        <v-card>

            <v-toolbar dense dark :color="toolbarColor">
                <v-toolbar-title class="white--text">Are you sure?</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="mt-2 mb-2 text-center">
                <v-icon size="70" color="yellow darken-2">mdi-alert</v-icon>
                <v-spacer></v-spacer>
                <span class="text-md-center">
                    Are you sure you want to delete user {{user.name}}? Please select an another user to take over
                    {{user.name}} responsibilities. We will assign projects and sub panels to the selected user.
                </span>

                <v-autocomplete
                    class="mt-8"
                    v-model="userModel"
                    :items="availableUsers"
                    filled
                    solo
                    background-color="grey darken-2"
                    item-text="name"
                    item-value="id"
                >
                    <template v-slot:selection="data">
                        <v-list-item-avatar>
                            <avatar large :image-url="data.item.photo_url" :person-name="data.item.name">
                            </avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title v-html="data.item.name"></v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <template v-slot:item="data">
                        <v-list-item-avatar>
                            <avatar large :image-url="data.item.photo_url" :person-name="data.item.name">
                            </avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title v-html="data.item.name"></v-list-item-title>
                        </v-list-item-content>
                    </template>

                </v-autocomplete>

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    :color="deleteButtonColor"
                    text-color="white"
                    @click="confirmClicked"
                >
                    {{ confirmButtonText }}
                </v-btn>

                <v-btn
                    color="white"
                    text
                    @click="abortClicked"
                >
                    {{ abortButtonText }}
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import Avatar from "../../../../components/UI/Avatar";

export default {

    components: {
        Avatar
    },

    props: {
        value: {
            type: Boolean,
            default: false,
            required: true
        },
        users: {
            type: Array,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
        description: {
            type: String,
            required: false,
        },
        confirmButtonText: {
            type: String,
            required: false,
            default: 'Confirm'
        },
        abortButtonText: {
            type: String,
            required: false,
            default: 'Abort'
        },
        delete: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    watch: {
        users() {
            this.selectCurrentUser();
        }
    },

    data() {
        return {
            dialog: false,
            userModel: null,
        }
    },

    computed: {
        dialogOpen: {
            get() {
                return this.value;
            },
            set() {
                this.closeDialog();
            }
        },
        toolbarColor() {
            return this.delete ? 'red darken-2' : 'primary';
        },
        deleteButtonColor() {
            return this.delete ? 'red darken-2' : 'primary';
        },
        availableUsers() {
            return this.users.filter(user => user.id !== this.user.id);
        }
    },

    methods: {

        selectCurrentUser() {
            this.userModel = this.users.find(user => user.id === this.$store.state.user.id);
        },

        closeDialog() {
            this.$emit('input', false);
        },

        confirmClicked() {
            this.$emit('input', false);
            this.$emit('data', {
                confirmed: true,
                assignTo: this.userModel,
            });
        },

        abortClicked() {
            this.$emit('input', false);
            this.$emit('data', {
                confirmed: false,
                assignTo: this.userModel,
            });
        }
    },

    mounted() {
        this.selectCurrentUser();
    }
}
</script>
